var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100.003,
    viewBox: "0 0 100 100.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19810",
    "data-name": "Rectangle 19810",
    className: "cls-1",
    width: 100,
    height: 100.003,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20069",
    "data-name": "Group 20069",
    transform: "translate(14290 680)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20025",
    "data-name": "Group 20025",
    className: "cls-2",
    transform: "translate(-14290 -680)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10013",
    "data-name": "Path 10013",
    className: "cls-1",
    d: "M1075.978,30.365c-.332-.663-.676-1.321-.99-1.992-.2-.428-.375-.87-.534-1.315-.226-.629-.442-1.263-.629-1.9a12.82,12.82,0,0,1-.456-1.859,23.287,23.287,0,0,1-.333-4c.022-.535.057-1.069.089-1.6a10.42,10.42,0,0,1,.077-1.086,14.173,14.173,0,0,1,.342-1.561c.243-.855.5-1.71.794-2.547a13.2,13.2,0,0,1,.808-1.845c.4-.744.881-1.448,1.324-2.171a.39.39,0,0,0,.028-.115l.4-.5c.089-.1.179-.2.265-.3.4-.463.781-.937,1.193-1.386a19.022,19.022,0,0,1,1.7-1.616,21.057,21.057,0,0,1,3.607-2.423,16.775,16.775,0,0,1,2.327-.993A20.087,20.087,0,0,1,1090.95.076l.868-.078h1.445l.871.071c.565.066,1.134.108,1.695.2A19.468,19.468,0,0,1,1111.9,16.51c.1.681.168,1.367.251,2.051-.127.146,0,.3,0,.447-.016.488,0,.977.008,1.465a4.554,4.554,0,0,0-.092.623,12.776,12.776,0,0,1-.237,1.993,18.3,18.3,0,0,1-.535,2.345,26.945,26.945,0,0,1-.966,2.643,37.639,37.639,0,0,1-3.156,5.751c-.924,1.422-1.877,2.824-2.818,4.234l-.074.076c-.133.2-.265.4-.4.6-.753,1.109-1.521,2.209-2.256,3.33-.652,1-1.3,2-1.891,3.032s-1.141,2.122-1.7,3.191c-.328.633-.661,1.267-.942,1.922-.327.76-.6,1.541-.9,2.315a43.728,43.728,0,0,0-1.629,5.4c-.222.933-.383,1.881-.566,2.823-.042.218-.066.44-.089.662-.057.568-.115,1.137-.16,1.706a1.132,1.132,0,0,1-1.183,1.007c-.146-.01-.292-.014-.438-.02l-.634-.717c-.177-1.293-.325-2.591-.54-3.877a36.922,36.922,0,0,0-1.889-6.905,35.869,35.869,0,0,0-2-4.5c-.472-.872-.955-1.739-1.438-2.605-.334-.6-.654-1.209-1.021-1.788q-1.252-1.97-2.546-3.912c-.372-.565-.779-1.107-1.171-1.659-.28-.435-.551-.876-.841-1.3-1.384-2.045-2.758-4.1-3.934-6.271a1.887,1.887,0,0,0-.138-.194m9.8-10.782a6.835,6.835,0,0,0,6.826,6.872,6.849,6.849,0,0,0,.036-13.7,6.747,6.747,0,0,0-6.862,6.825",
    transform: "translate(-1016.374 2.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10014",
    "data-name": "Path 10014",
    className: "cls-1",
    d: "M418.926,661.509c-1.09,0-2.179-.012-3.269-.018l-.089-.095h0c0,.033-.01.066-.015.1a2.049,2.049,0,0,0,.455.106q3.273.007,6.547,0a2.537,2.537,0,0,0-.457-.085c-1.058-.008-2.115,0-3.173,0",
    transform: "translate(-395.247 -629.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10015",
    "data-name": "Path 10015",
    className: "cls-1",
    d: "M549.782,665.552a5.527,5.527,0,0,1-.465,1.491,5.527,5.527,0,0,0,.465-1.491",
    transform: "translate(-522.474 -633.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10016",
    "data-name": "Path 10016",
    className: "cls-1",
    d: "M367.335,762.247l-2.029,0a7.846,7.846,0,0,1-1.57-.355,7.846,7.846,0,0,0,1.57.355,4.867,4.867,0,0,0,2.029,0",
    transform: "translate(-345.962 -724.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10017",
    "data-name": "Path 10017",
    className: "cls-1",
    d: "M415.92,559.183q5.963,0,11.927,0a2.3,2.3,0,0,0-.46-.1q-5.693-.008-11.386,0a2.044,2.044,0,0,0-.456.107l.015.1h0l.07-.091c.1-.008.194-.022.29-.022",
    transform: "translate(-395.239 -531.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10018",
    "data-name": "Path 10018",
    className: "cls-1",
    d: "M397.878,447.716l1.821,0c.248.041.5.067.745.119-.245-.052-.5-.079-.745-.119a4.194,4.194,0,0,0-1.821,0",
    transform: "translate(-378.435 -425.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10019",
    "data-name": "Path 10019",
    className: "cls-1",
    d: "M368.924,344.141q.233-.048.464-.1-.231.051-.464.1",
    transform: "translate(-350.896 -327.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10020",
    "data-name": "Path 10020",
    className: "cls-1",
    d: "M355.3,758.58c.091.04.182.076.274.111-.092-.035-.183-.072-.274-.111",
    transform: "translate(-337.942 -721.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10021",
    "data-name": "Path 10021",
    className: "cls-1",
    d: "M364.323,346.166l.209-.043-.209.043",
    transform: "translate(-346.52 -329.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10022",
    "data-name": "Path 10022",
    className: "cls-1",
    d: "M343.172,350.239c.1-.027.207-.052.31-.076-.1.023-.207.049-.31.076",
    transform: "translate(-326.403 -333.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10023",
    "data-name": "Path 10023",
    className: "cls-1",
    d: "M374.185,874.649c-.3-.04-.6-.062-.893-.1.3.041.6.063.893.1l.689,0a.715.715,0,0,0-.689,0",
    transform: "translate(-355.051 -831.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10024",
    "data-name": "Path 10024",
    className: "cls-1",
    d: "M425.5,875.1l.592,0c.214-.028.427-.053.641-.08-.214.026-.427.052-.641.08a.568.568,0,0,0-.592,0",
    transform: "translate(-404.705 -832.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10025",
    "data-name": "Path 10025",
    className: "cls-1",
    d: "M381.157,339.628a5.414,5.414,0,0,0-2.344.09l-.144.033.144-.033,2.344-.09",
    transform: "translate(-360.166 -322.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10026",
    "data-name": "Path 10026",
    className: "cls-1",
    d: "M430.8,341.593l-.964-.09h0l.964.09",
    transform: "translate(-408.826 -324.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10027",
    "data-name": "Path 10027",
    className: "cls-1",
    d: "M52.553,218.991a12.519,12.519,0,0,1,.094-1.32,17.46,17.46,0,0,1,.415-1.9c.3-1.04.6-2.079.966-3.1a16.016,16.016,0,0,1,.983-2.243c.49-.9,1.071-1.76,1.61-2.639a.475.475,0,0,0,.034-.14c-.211-.011-.422-.03-.632-.03q-24.4,0-48.8.006a7.02,7.02,0,0,0-5.216,2.262A6.965,6.965,0,0,0,.488,212.37a3.019,3.019,0,0,1-.256.449.392.392,0,0,0-.036.088l0,.1.007.106a1.342,1.342,0,0,1-.2.965v76.254c.162-.134.336-.256.484-.4Q7.32,283.1,14.151,276.264c.39-.39.782-.779,1.17-1.171,2.769-2.795,5.525-5.6,8.307-8.384q9.5-9.5,19.027-18.99,6.47-6.468,12.918-12.957a5.58,5.58,0,0,1,.447-.366c-.4-.806-.82-1.606-1.2-2.422-.244-.52-.456-1.058-.649-1.6-.273-.765-.536-1.535-.763-2.315a15.439,15.439,0,0,1-.554-2.26,28.2,28.2,0,0,1-.4-4.861c.027-.65.069-1.3.107-1.949M32.719,229.475c-.116.618-.156,1.255-.32,1.86a11.45,11.45,0,0,1-6.5,7.861,11.959,11.959,0,0,1-3.239.959c-.213.031-.427.059-.64.086l-.641.08-.592,0h-.969l-.689,0c-.3-.04-.6-.062-.892-.1a4.462,4.462,0,0,1-.526-.1,22.159,22.159,0,0,1-2.253-.7,12.388,12.388,0,0,1-3.834-2.355A13.2,13.2,0,0,1,8.395,232.7a15.229,15.229,0,0,1-.887-2.663,12.784,12.784,0,0,1-.28-3.467,11.071,11.071,0,0,1,.8-3.9,12.889,12.889,0,0,1,8.129-7.828c.2-.068.4-.128.611-.181q.155-.04.31-.075c.24-.056.481-.105.723-.155l.209-.043.016,0c.155-.032.31-.064.464-.1l.013,0,.143-.033a5.415,5.415,0,0,1,2.344-.09h.015l.964.09c.657.136,1.325.232,1.969.415a11.72,11.72,0,0,1,5.037,2.858l.006-.006c0,.007,0,.012,0,.017s.005.018,0,0l0,0-.009-.008-3.721,3.722c-.042-.033-.157-.115-.264-.206a7,7,0,0,0-2.877-1.448l-.1-.024c-.245-.052-.5-.078-.745-.119l-1.821,0a7.067,7.067,0,0,0-2.665.816,7.808,7.808,0,0,0-3.656,4.034,7.573,7.573,0,0,0-.188,5.335,7.96,7.96,0,0,0,4.158,4.785q.135.068.271.127t.274.112l.138.05a7.794,7.794,0,0,0,1.57.355l2.029,0a5.875,5.875,0,0,0,1.872-.42,6.339,6.339,0,0,0,2.741-1.848,5.891,5.891,0,0,0,.857-1.305A5.55,5.55,0,0,0,27.308,230h0c-2.182,0-4.364.007-6.547,0a2.05,2.05,0,0,1-.455-.106l.015-.1q0-2.4,0-4.79h0l-.015-.1a2.025,2.025,0,0,1,.455-.107q5.693-.009,11.386,0a2.261,2.261,0,0,1,.46.1c.083.619.19,1.237.242,1.858a10.1,10.1,0,0,1-.13,2.715",
    transform: "translate(0 -197.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10028",
    "data-name": "Path 10028",
    className: "cls-1",
    d: "M593.193,410.532c0,.018.006.008,0,0",
    transform: "translate(-564.206 -390.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10029",
    "data-name": "Path 10029",
    className: "cls-1",
    d: "M349.526,347.153c.24-.055.482-.1.723-.155-.241.05-.483.1-.723.155",
    transform: "translate(-332.446 -330.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10030",
    "data-name": "Path 10030",
    className: "cls-1",
    d: "M368.6,346.061l.016,0-.016,0",
    transform: "translate(-350.587 -329.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10031",
    "data-name": "Path 10031",
    className: "cls-1",
    d: "M592.988,410.208l0-.017-.006.006.009.008s0,0,0,0",
    transform: "translate(-564.001 -390.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10032",
    "data-name": "Path 10032",
    className: "cls-1",
    d: "M558.841,665.553Z",
    transform: "translate(-531.533 -633.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10033",
    "data-name": "Path 10033",
    className: "cls-1",
    d: "M405.659,876.737Z",
    transform: "translate(-385.836 -833.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10034",
    "data-name": "Path 10034",
    className: "cls-1",
    d: "M429.565,341.475h0",
    transform: "translate(-408.574 -324.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10035",
    "data-name": "Path 10035",
    className: "cls-1",
    d: "M415.849,563.374h0q0,2.4,0,4.791,0-2.4,0-4.791",
    transform: "translate(-395.528 -535.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10036",
    "data-name": "Path 10036",
    className: "cls-1",
    d: "M378.409,343.986l.013,0-.013,0",
    transform: "translate(-359.918 -327.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10037",
    "data-name": "Path 10037",
    className: "cls-1",
    d: "M1563.051,995.21c-.136-.115-.279-.221-.4-.346q-7.066-7.061-14.126-14.125c-.115-.115-.222-.237-.334-.356.178.007.356.012.535.024a1.376,1.376,0,0,0,1.438-1.224c.054-.693.125-1.384.193-2.074.028-.269.058-.539.109-.8.223-1.145.417-2.3.688-3.432a52.7,52.7,0,0,1,1.981-6.562c.358-.94.693-1.891,1.091-2.815.344-.8.746-1.566,1.146-2.336.674-1.3,1.331-2.611,2.062-3.879s1.5-2.475,2.3-3.687c.894-1.363,1.828-2.7,2.743-4.048.162-.242.323-.485.486-.728a.387.387,0,0,0,.084.014c0,.26.007.521.009.78q0,22.8,0,45.6",
    transform: "translate(-1472.533 -902.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10038",
    "data-name": "Path 10038",
    className: "cls-1",
    d: "M1108.313,979.446a3.8,3.8,0,0,1-.465-.344q-10.509-10.5-21.009-21.008c-.114-.114-.21-.245-.316-.369.119-.132.233-.27.357-.4,1.179-1.182,2.366-2.359,3.542-3.545q2.311-2.33,4.612-4.671c.125-.126.26-.243.389-.364.476.671.972,1.33,1.426,2.017,1.042,1.577,2.078,3.159,3.092,4.756.447.7.835,1.445,1.242,2.173.587,1.053,1.174,2.107,1.748,3.167a43.627,43.627,0,0,1,2.43,5.474,44.952,44.952,0,0,1,2.295,8.4c.262,1.564.441,3.142.658,4.714",
    transform: "translate(-1033.428 -902.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10039",
    "data-name": "Path 10039",
    className: "cls-1",
    d: "M210,1291.868c.132.122.268.237.394.363q4.868,4.865,9.733,9.732c.377.38.716.8,1.094,1.174q12.407,12.369,24.821,24.733c.092.092.193.174.29.26.142.168.284.339.5.6h-21.2l-51.682,0c-.26,0-.52-.013-.78-.021.649-.661,1.294-1.326,1.948-1.981q11.281-11.281,22.563-22.562c2.079-2.081,4.132-4.188,6.212-6.269,1.965-1.965,3.95-3.911,5.926-5.864.058-.057.122-.107.183-.161",
    transform: "translate(-164.71 -1228.739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/google_maps.4dcbf7abe4c0f7248b92d17e0143a5c9.svg";
export { ForwardRef as ReactComponent };